module.exports = __webpack_public_path__ + "static/media/visa-icon-white.b7857132.svg";